import React, { createContext, useContext, useState, useCallback } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// 1) Create a context object
export const SnackbarContext = createContext(null);

// 2) Build a provider component
export const SnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");
  const [autoHideDuration, setAutoHideDuration] = useState(6000);
  const [anchorOrigin, setAnchorOrigin] = useState({
    vertical: "top",
    horizontal: "center",
  });

  // function to show the snackbar from anywhere
  const showSnackbar = useCallback(
    ({
      message: newMessage,
      severity: newSeverity = "info",
      autoHide = 10000,
      anchor = { vertical: "top", horizontal: "center" },
    }) => {
      setMessage(newMessage);
      setSeverity(newSeverity);
      setAutoHideDuration(autoHide);
      setAnchorOrigin(anchor);
      setOpen(true);
    },
    []
  );

  // function to close
  const hideSnackbar = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      {/* Render the actual Snackbar once, using context’s state */}
      <Snackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={hideSnackbar}
        anchorOrigin={anchorOrigin}
      >
        <Alert onClose={hideSnackbar} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};